import {useFormikContext} from 'formik';
import {OneAddressType} from '../types/DeliveryData';
import {useCreateAddressMutation} from '../redux/deliveryApi';

export const useDeliveryForm = () => {
	const {values, setFieldValue} = useFormikContext<any>();
	const [createAddress, {isLoading: isCreatingAddress}] = useCreateAddressMutation();

	const handleChangeAddress = (address: OneAddressType) => {
		// Format address name with street type prefix for Nova Poshta
		let formattedAddressName = address.address_name;
		if (values.service_name?.toLowerCase().includes('нова') || values.service_name?.toLowerCase().includes('nova')) {
			// For Nova Poshta, add street type prefix if not already present
			if (formattedAddressName && !formattedAddressName.includes('вул.') && !formattedAddressName.includes('пр.') && !formattedAddressName.includes('пл.') && !formattedAddressName.includes('пров.')) {
				formattedAddressName = `вул.${formattedAddressName}`;
			}
		}
		
		setFieldValue('address_name', formattedAddressName);
		setFieldValue('building', address.building);
		setFieldValue('city_name', address.city_name);
		setFieldValue('country_name', address.country_name);
		setFieldValue('delivery_type', address.delivery_type);
		setFieldValue('flat', address.flat);
		setFieldValue('region_name', address.region_name);
	};

	const handleCreateAddress = async () => {
		// Format city name with settlement type for Nova Poshta
		let formattedCityName = values.city_name;
		let formattedAddressName = values.address_name;
		
		if (values.service_name?.toLowerCase().includes('нова') || values.service_name?.toLowerCase().includes('nova')) {
			// For Nova Poshta, add settlement type prefix if not already present
			if (!formattedCityName.includes('м.') && !formattedCityName.includes('с.') && !formattedCityName.includes('смт.')) {
				formattedCityName = `м.${formattedCityName}`;
			}
			
			// For Nova Poshta, add street type prefix if not already present
			if (formattedAddressName && !formattedAddressName.includes('вул.') && !formattedAddressName.includes('пр.') && !formattedAddressName.includes('пл.') && !formattedAddressName.includes('пров.')) {
				formattedAddressName = `вул.${formattedAddressName}`;
			}
		}

		const data = {
			service_type: values.service_type,
			delivery_type: values.delivery_type,
			region_name: values.region_name,
			region_ref: values.region_ref,
			city_name: formattedCityName,
			city_ref: values.city_ref,
			address_name: formattedAddressName,
			address_ref: values.address_ref,
			building: values.building,
			flat: values.flat,
		};

		try {
			await createAddress(data).unwrap();
			// Success: RTK Query will automatically invalidate and refetch addresses list
			// Clear form fields after successful creation
			const newData = Object.keys(data).reduce((acc: any, key) => {
				if (key !== 'service_type' && key !== 'delivery_type') {
					acc[key] = '';
				} else {
					acc[key] = data[key];
				}
				return acc;
			}, {});
			handleChangeAddress(newData);
			return data;
		} catch (error) {
			console.error('Failed to create address:', error);
			throw error;
		}
	};

	return {
		handleChangeAddress,
		handleCreateAddress,
		isCreatingAddress,
	};
};
